export default __webpack_public_path__ + "static/media/assetMain.673e0f40.svg";